import React, { useEffect, useState } from 'react';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import ImageListItem from '@mui/material/ImageListItem';
import { CircularProgress, ImageListItemBar, IconButton, Skeleton } from '@mui/material';
import { useNavigate } from "react-router-dom";
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { doc, updateDoc } from "firebase/firestore";
import { db } from '../../lib/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../lib/auth';


export default function OutfitsListItem({ outfit }) {
  const [url, setUrl] = useState(null);
  const navigate = useNavigate();
  const [favorite, setFavorite] = useState(false);
  const [user] = useAuthState(auth)

  useEffect(() => {
    const storage = getStorage();

    getDownloadURL(ref(storage, `outfits/${outfit.coverPhoto}_300x400`))
      .then((downloadURL) => {
        setUrl(downloadURL);
      })
      .catch(err => {
        console.error("Resized photo doesn't exist yet (probably)")
      })
    setFavorite(outfit.favorite);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outfit]);


  const handleShowOutfit = (outfit) => {
    navigate(`/showOutfit/${outfit.id}`)
  }


  const handleFavoriteClick = async (outfit) => {
    try {
      await updateDoc(doc(db, 'users', user.uid, 'outfits', outfit.id), {
        favorite: !favorite,
      });
      setFavorite(!favorite);
    } catch (error) {
      console.error("Error updating", error)
    }
  }


  return (
    <ImageListItem key={url}>
      {url ? (
        <img
          src={`${url}?w=248&fit=crop&auto=format`}
          srcSet={`${url}?w=248&fit=crop&auto=format&dpr=2 2x`}
          alt={outfit.title}
          loading="lazy"
          onClick={() => handleShowOutfit(outfit)}
        />)
        : (
          <Skeleton variant="rectangular" animation="wave" height={'100%'} />
        )
      }
      <ImageListItemBar
        sx={{
          background:
            'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
            'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
        }}
        position="top"
        actionIcon={
          <IconButton
            sx={{ color: 'white' }}
            onClick={() => handleFavoriteClick(outfit)}
          >
            {favorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
          </IconButton>
        }
        actionPosition="right"
      />
    </ImageListItem>
  )
}
